import { mapGetters } from "vuex";
import firebase from "firebase/app";
import deleteFirebase from "@/data/cloud/firebase/mixins/deleteFirebase.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import updateFirebase from "@/data/cloud/firebase/mixins/updateFirebase.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import actionFunctions from "@/business/actions/mixins/actionFunctions.js";
import workFunctions from "@/work/request/mixins/workFunctions.js";
import reportFunctions from "@/engineering/report/mixins/reportFunctions.js";
import docRevsFunctions from "@/document/revisions/mixins/docRevsFunctions.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";

export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [
    uisettings,
    dataSources,
    createFirebase,
    updateFirebase,
    docRevsFunctions,
    storeFunctions,
    relpsFunctions,
    actionFunctions,
    workFunctions,
    relationshipsFunctions,
    deleteFirebase,
    generateID,
    reportFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailPref",
      "getDetailRev",
      "getDetailRisk",
      "getDetailLink",
      "getTransitions",
      "getRolesList",
      "getSearchResults",
      "getResultsList"
    ]),
    dataDetail() {
      if (this.getCurrentPage == "/maintstrategyedit") {
        // return this.getMaintStrategy;
      }
    },
    // ds() {
    //   return this.data;
    // },
    ui() {
      return this.uiTheme1;
    }
  },
  methods: {
    changeDetail() {
      // u updated data that you want to send
      if (this.dbSource !== null) {
        this.btnSpinChangeDetail = true;

        // DETAIL
        let temp = this.getDetail;
        let tag = this.getDetail.basic.tag;

        // RESET
        // temp.basic.list = false;
        // console.log(temp);

        // BASIC
        if (this.getDetailBasic !== undefined && this.getDetailBasic !== null) {
          temp.basic = this.getDetailBasic;
        }
        // CHAR
        if (this.getDetailChar !== undefined && this.getDetailChar !== null) {
          temp.char = this.getDetailChar;
        }
        // PREF
        if (this.getDetailPref !== undefined && this.getDetailPref !== null) {
          temp.pref = this.getDetailPref;
        }
        // REV
        if (this.getDetailRev !== undefined && this.getDetailRev !== null) {
          temp.rev = this.updateDocumentRev();
        }
        // LINK
        // eslint-disable-next-line
        if (this.getDetailLink !== undefined && this.getDetailLink !== null) {
          temp.link = this.getDetailLink;
        }
        // RISK
        if (this.getDetailRisk !== undefined && this.getDetailRisk !== null) {
          temp.risk = this.getDetailRisk;
        }
        // TRANS
        if (this.getTransitions !== undefined && this.getTransitions !== null) {
          temp.trans = this.getTransitions;
        }
        // RELPS AND STATS
        if (this.getDetailRelps !== undefined && this.getDetailRelps !== null) {
          // console.log(">>> UPDATE HERE RELPS AND STATS <<<");
          // REMOTE RELPS is updated in core functions
          this.updateDetailRelpsAndStats();
        }
        // ACTION ASSIGNEE // Generate COPY
        // eslint-disable-next-line
        if (
          tag === "B3" &&
          this.getRolesList !== undefined &&
          this.getRolesList !== null
        ) {
          // create action
          this.updateActionForUser();
        }

        // WORK PLAN - Generate Copy
        // eslint-disable-next-line
        if (tag === "W1" && temp.char.planDid !== undefined && temp.char.planDid !== null) {
          this.updatePlanWorkList();
        }

        // GENERARTE REPORT FROM WORK
        if (tag === "W1" || tag === "W2" || tag === "W3") {
          let transStatus = temp.trans.flow[temp.trans.flow.length - 1].title;
          if (transStatus === "closed" || transStatus === "Closed") {
            this.generateReportFromWork(this.getDetail, this.getResultsList);
          }
        }

        // console.log("");
        // console.log("---ooo--- CHANGE DETAIL [DOC]   ---ooo---");
        // console.log(temp);

        // RESET Relps Lists (New)
        // eslint-disable-next-line
        this.$store.dispatch("changeActionNewDocumentList", null);

        // UPDATE DETAIL
        this.updateStoreDetail(tag, temp);

        // UPDATE the DATABASE
        let db = null;
        let did = temp.basic.did;
        // ACTON TYPE is SPECIAL
        if (tag === "B3" && temp.link.cdid !== undefined) {
          // console.log("ACTION CHANGE in STATUS");
          // DEFINE DB
          let cdid = temp.link.cdid;
          db = firebase.firestore().collection("governance");
          db = db.doc(cdid).collection("action");
          // UPDATE STORE
          let transStatus = temp.trans.flow[temp.trans.flow.length - 1].title;
          this.$store.dispatch("changeTransitionStatusPrevious", transStatus);
          this.$store.dispatch("changeTransitionStatusCurrent", transStatus);
        } else {
          db = this.defineDataSourceFromTag(tag);
        }
        // UPDATE DOC DIRECT (MOST CASES)
        this.updateFirebaseDocumentDirect(db, did, temp);
      }
    }
  }
};
